/**
 * Television: DiscountedPrice × (BoughtSeconds / 10) × unit × timeline
 *
 * Timeslot is always priced per 10-second slot (global media pricing unit).
 * Timeline is taken as-is from selection.
 */
import { slotTenFactor } from './multipliers';

export function calculateTelevisionTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  const timeline = Number(selection?.timelineToBought) || 1;
  const slot = slotTenFactor(selection?.BoughtSeconds);
  return discountedPrice * slot * units * timeline;
}
